import * as request from '../api-request'

export const upsertScene = async (data = {}) => {
  return request.toJSON('POST', 'script_breakdown/scenes', data)
}

export const upsertElements = async (data = {}, token) => {
  return request.toJSON('POST', 'script_breakdown/elements', data)
}

// Server searches the script and tags every scene the element appears in.
export const tagElementInAllScenes = async (data = {}) => {
  return request.toJSON('POST', 'script_breakdown/elements/tag_all', data)
}

// Server removes the element from every scene except `exceptSceneUuid`, which
// was already handled locally.
export const removeElementFromAllScenes = async (data = {}) => {
  return request.toJSON('POST', 'script_breakdown/elements/remove_all', data)
}

export const getScene = async (data = {}, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `script_breakdown/scenes?${queryString}`, data)
}

export const getAllElements = async (data = {}, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `script_breakdown/all_elements?${queryString}`, data)
}

export const getSceneElements = async (data = {}) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `script_breakdown/scene/elements?${queryString}`, data)
}

export const breakdownRenderPreview = async (data = {}) => {
  return request.toBlob('POST', 'script_breakdown/breakdown_summary', data)
}

export const createBreakdownJob = async (data, token) => {
  return request.toJSON('POST', 'script_breakdown/automatic_breakdown', data)
}

export const cancelAutomaticBreakdown = async (data, token) => {
  return request.toJSON('POST', 'script_breakdown/cancel_automatic_breakdown', data)
}

export const getJobStatus = async (data, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `script_breakdown/automatic_breakdown?${queryString}`, data)
}

export const createSceneDetailsJob = async (data, token) => {
  return request.toJSON('POST', 'script_breakdown/scene_details_job', data)
}

export const getSceneDetailsJobStatus = async (data, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `script_breakdown/scene_details_job?${queryString}`, data)
}

export const cancelSceneDetailsJob = async (data, token) => {
  return request.toJSON('POST', 'script_breakdown/cancel_scene_details_job', data)
}

export const checkPermission = async (data, token) => {
  return request.toJSON('POST', 'script_breakdown/check_permission', data)
}

export const createCustomElement = async (data) => {
  return request.toJSON('POST', 'script_breakdown/custom_element', data)
}

export const getCustomElements = async () => {
  return request.toJSON('GET', 'script_breakdown/custom_elements')
}

// Drops a custom category's tags from every scene of this script.
export const clearCustomCategory = async (data = {}) => {
  return request.toJSON('POST', 'script_breakdown/elements/clear_category', data)
}

export const deleteCustomElement = async (id) => {
  return request.toJSON('DELETE', `script_breakdown/custom_element/${id}`)
}

export const swapScenes = async (data) => {
  return request.toJSON('POST', 'script_breakdown/swap_scenes', data)
}

export const exportFdx = async (data = {}) => {
  return request.toBlob('POST', 'script_breakdown/export_fdx', data)
}

export const preview = async (data = {}, token, signal) => {
  return request.toBlob('POST', 'script_breakdown/preview', data, token, signal)
}

export const getCast = async (data = {}, token) => {
  const queryString = request.createQueryString(data)
  return request.toJSON('GET', `script_breakdown/cast?${queryString}`, data, token)
}

export const updateCast = async (data = {}, token) => request.toJSON('POST', 'script_breakdown/cast/update', data, token)

export const mergeCast = async (data = {}, token) => request.toJSON('POST', 'script_breakdown/cast/merge', data, token)

export const splitCast = async (data = {}, token) => request.toJSON('POST', 'script_breakdown/cast/split', data, token)

// Renaming a character rewrites the tags the breakdown holds as well as the
// cast entry, so the old name does not come back as a second person.
export const renameCast = async (data = {}, token) => request.toJSON('POST', 'script_breakdown/cast/rename', data, token)
